import React, { Suspense, lazy } from 'react';

import '../design/styles/modules.css'
import imgLoading from '../design/icons/loading.svg'

const Admin = lazy(() => import (/*webpackChunkName: "Admin" */ '../modules/admin/Admin.jsx'))
const Finance = lazy(() => import (/*webpackChunkName: "Finance" */ '../modules/finance/Finance.jsx'))
const Taxes = lazy(() => import (/*webpackChunkName: "Taxes" */ '../modules/taxes/Taxes.jsx'))
const Hotel = lazy(() => import (/*webpackChunkName: "Hotel" */ '../modules/hotel/Hotel.jsx'))
const Settings = lazy(() => import(/* webpackChunkName: "Settings" */ '../modules/settings/Settings.jsx'))
const Labor = lazy(() => import(/* webpackChunkName: "Labor" */ '../modules/labor/Labor.jsx'))
const Metrics = lazy(() => import(/* webpackChunkName: "Metrics" */ '../modules/metrics/Metrics.jsx'))
const Costing = lazy(() => import(/* webpackChunkName: "Costing" */ '../modules/costing/Costing.jsx'))
const Accounting = lazy(() => import(/* webpackChunkName: "Accounting" */ '../modules/accounting/Accounting.jsx'))
const MercadoLibre = lazy(() => import(/* webpackChunkName: "MercadoLibre" */ '../modules/mercadolibre/MercadoLibre.jsx'))
const Support = lazy(() => import(/* webpackChunkName: "Support" */ '../modules/support/Support.jsx'))
const Agro = lazy(() => import(/* webpackChunkName: "Agro" */ '../modules/agro/Agro.jsx'))
const Suscripciones = lazy(() => import(/* webpackChunkName: "Suscripciones" */ '../modules/suscripciones/Suscripciones.jsx'))
const Bodegas = lazy(() => import(/* webpackChunkName: "Bodegas" */ '../modules/bodegas/Bodegas.jsx'))

const Modules = ( props ) => {

  return(
    <div id= "modules" className = "modules">
      { props.module && props.module[0] === 'adm' &&
         <Suspense fallback={<img src={imgLoading} alt = "Cargando..." />}>
           <Admin
             Alert={props.Alert}
             module={props.module[1]}
             subModule={props.module[2]}
             onCloseModule={() => props.setModule(null)}
           />
         </Suspense>
      }
         { props.module && props.module[0] === 'fin' &&
         <Suspense fallback={<img src={imgLoading} alt = "Cargando..." />}>
           <Finance Alert={props.Alert} module={props.module[1]} />
         </Suspense>
      }
      { props.module && props.module[0] === 'tax' &&
         <Suspense fallback={<img src={imgLoading} alt = "Cargando..." />}>
           <Taxes Alert={props.Alert} module={props.module[1]} />
         </Suspense>
      }
      { props.module && props.module[0] === 'hot' &&
         <Suspense fallback={<img src={imgLoading} alt = "Cargando..." />}>
           <Hotel Alert={props.Alert} module={props.module[1]} />
         </Suspense>
      }
      {props.module && props.module[0] === 'settings' && (
        <Suspense fallback={<img src={imgLoading} alt="Cargando..." />}>
          <Settings submodule={props.module[1]} Alert={props.Alert} setModule={props.setModule} />
        </Suspense>
      )}
      {props.module && props.module[0] === 'lab' && (
        <Suspense fallback={<img src={imgLoading} alt="Cargando..." />}>
          <Labor Alert={props.Alert} module={props.module[1]} />
        </Suspense>
      )}
      {props.module && props.module[0] === 'met' && (
        <Suspense fallback={<img src={imgLoading} alt="Cargando..." />}>
          <Metrics Alert={props.Alert} module={props.module[1]} />
        </Suspense>
      )}
      {props.module && props.module[0] === 'cos' && (
        <Suspense fallback={<img src={imgLoading} alt="Cargando..." />}>
          <Costing Alert={props.Alert} module={props.module[1]} />
        </Suspense>
      )}
      {props.module && props.module[0] === 'acc' && (
        <Suspense fallback={<img src={imgLoading} alt="Cargando..." />}>
          <Accounting Alert={props.Alert} module={props.module[1]} />
        </Suspense>
      )}
      {props.module && props.module[0] === 'mel' && (
        <Suspense fallback={<img src={imgLoading} alt="Cargando..." />}>
          <MercadoLibre Alert={props.Alert} module={props.module[1]} />
        </Suspense>
      )}
      {props.module && props.module[0] === 'sup' && (
        <Suspense fallback={<img src={imgLoading} alt="Cargando..." />}>
          <Support Alert={props.Alert} module={props.module[1]} />
        </Suspense>
      )}
      {props.module && props.module[0] === 'agr' && (
        <Suspense fallback={<img src={imgLoading} alt="Cargando..." />}>
          <Agro Alert={props.Alert} module={props.module[1]} />
        </Suspense>
      )}
      {props.module && props.module[0] === 'sub' && (
        <Suspense fallback={<img src={imgLoading} alt="Cargando..." />}>
          <Suscripciones Alert={props.Alert} module={props.module[1]} />
        </Suspense>
      )}
      {props.module && props.module[0] === 'bod' && (
        <Suspense fallback={<img src={imgLoading} alt="Cargando..." />}>
          <Bodegas Alert={props.Alert} module={props.module[1]} />
        </Suspense>
      )}
    </div>
  )
}

export default Modules